
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexfgHReLJ5Ncq3vHju383SsGAZz3fBV7yUusy_lvGdY8cMeta } from "/app/packages/web/pages/index.vue?macro=true";
import { default as loginKSHnJhq2TB1U6MGle4Sp0MjrQFEQk4uwDkFv7SX1nGUMeta } from "/app/packages/web/pages/login.vue?macro=true";
import { default as statsg33_45pJvCsLnI18Ls1VnonRNKe3_NCh58O_45CL6j_45EKx0Meta } from "/app/packages/web/pages/stats.vue?macro=true";
import { default as usersQ7l6ZvNz3h1y0442zSlRm68MZ9wBg1YYyeACvSgLQDUMeta } from "/app/packages/web/pages/users.vue?macro=true";
import { default as creator4u9avgmp_YfrThN3sl89AFFMJNq2cUzzyOEvHEXsuJwMeta } from "/app/packages/web/pages/creator.vue?macro=true";
import { default as reviewsnh0WEjaRQkdCQiuVaBsLPs9fflxJe7zmrW1TgmQC_45AcMeta } from "/app/packages/web/pages/reviews.vue?macro=true";
import { default as kategorienalHnb1LCtEjZHU_45loza4K2j4lMJpPadQ2qUwWw31DE4Meta } from "/app/packages/web/pages/kategorien.vue?macro=true";
import { default as leseplaenev6IrpBNtFa6aN_CLnx37KbLv_qcRHDskXYFXsOUELSoMeta } from "/app/packages/web/pages/leseplaene.vue?macro=true";
import { default as loginInternh07dO00YtnP2ZyQpSNOSJ3LO61JdDhMDA9Ep7LEN2P8Meta } from "/app/packages/web/pages/loginIntern.vue?macro=true";
import { default as _91id_93qd9_45OYG3X6k6x43PF_Icl1bNmNqrfn8cb6lI0VpGorIMeta } from "/app/packages/web/pages/reader/[id].vue?macro=true";
import { default as creator_45statsPQVjmOqzJkJqizTOKoD938Z1DNpegx_p7P9S_45a5ymSAMeta } from "/app/packages/web/pages/creator-stats.vue?macro=true";
import { default as _91id_93wE_45kLCIAyyAFbBIdF4N_45d48mBTk8McKSdJH5gB0FT1cMeta } from "/app/packages/web/pages/leseplan/[id].vue?macro=true";
import { default as loginSelectionQqx_45YMR7etGPllQH_45_45dVMYGk1H7MeKMgPgnmP77RnrkMeta } from "/app/packages/web/pages/loginSelection.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/packages/web/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKSHnJhq2TB1U6MGle4Sp0MjrQFEQk4uwDkFv7SX1nGUMeta || {},
    component: () => import("/app/packages/web/pages/login.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: statsg33_45pJvCsLnI18Ls1VnonRNKe3_NCh58O_45CL6j_45EKx0Meta || {},
    component: () => import("/app/packages/web/pages/stats.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: usersQ7l6ZvNz3h1y0442zSlRm68MZ9wBg1YYyeACvSgLQDUMeta || {},
    component: () => import("/app/packages/web/pages/users.vue")
  },
  {
    name: "creator",
    path: "/creator",
    meta: creator4u9avgmp_YfrThN3sl89AFFMJNq2cUzzyOEvHEXsuJwMeta || {},
    component: () => import("/app/packages/web/pages/creator.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    meta: reviewsnh0WEjaRQkdCQiuVaBsLPs9fflxJe7zmrW1TgmQC_45AcMeta || {},
    component: () => import("/app/packages/web/pages/reviews.vue")
  },
  {
    name: "kategorien",
    path: "/kategorien",
    meta: kategorienalHnb1LCtEjZHU_45loza4K2j4lMJpPadQ2qUwWw31DE4Meta || {},
    component: () => import("/app/packages/web/pages/kategorien.vue")
  },
  {
    name: "leseplaene",
    path: "/leseplaene",
    meta: leseplaenev6IrpBNtFa6aN_CLnx37KbLv_qcRHDskXYFXsOUELSoMeta || {},
    component: () => import("/app/packages/web/pages/leseplaene.vue")
  },
  {
    name: "loginIntern",
    path: "/loginIntern",
    meta: loginInternh07dO00YtnP2ZyQpSNOSJ3LO61JdDhMDA9Ep7LEN2P8Meta || {},
    component: () => import("/app/packages/web/pages/loginIntern.vue")
  },
  {
    name: "reader-id",
    path: "/reader/:id()",
    meta: _91id_93qd9_45OYG3X6k6x43PF_Icl1bNmNqrfn8cb6lI0VpGorIMeta || {},
    component: () => import("/app/packages/web/pages/reader/[id].vue")
  },
  {
    name: "creator-stats",
    path: "/creator-stats",
    meta: creator_45statsPQVjmOqzJkJqizTOKoD938Z1DNpegx_p7P9S_45a5ymSAMeta || {},
    component: () => import("/app/packages/web/pages/creator-stats.vue")
  },
  {
    name: "leseplan-id",
    path: "/leseplan/:id()",
    meta: _91id_93wE_45kLCIAyyAFbBIdF4N_45d48mBTk8McKSdJH5gB0FT1cMeta || {},
    component: () => import("/app/packages/web/pages/leseplan/[id].vue")
  },
  {
    name: "loginSelection",
    path: "/loginSelection",
    meta: loginSelectionQqx_45YMR7etGPllQH_45_45dVMYGk1H7MeKMgPgnmP77RnrkMeta || {},
    component: () => import("/app/packages/web/pages/loginSelection.vue")
  }
]